import React, { useContext, useEffect } from 'react';
import api from './services/api';

import { RouterContext } from './contexts/routerContext';

import HomeScreen from './screens/home';
import MakeACallScreen from './screens/make-a-call';

import ScheduleScreen from './screens/schedule';
import DetailsContactScreen from './screens/details-contact';
import DetailHistoryScreen from './screens/detail-history';
import EditContactScreen from './screens/edit-contact';
import CreateContactScreen from './screens/create-contact';

import SendMessagesScreen from './screens/send-messages';

import SettingsScreen from './screens/settings';
import ProfileScreen from './screens/profile';
import ThemesScreen from './screens/themes-settings';
import SoundSettingsScreen from './screens/sound-settings';
import CallInProgress from './screens/call-in-progress';

function Router({
    handleExecCall,
    handleMuteCall,
    handleEndCall,
}) {
    const { router } = useContext(RouterContext);

    return (
        <>
            {router === 'make-a-call' && (
                <MakeACallScreen handleExecCall={handleExecCall} />
            )}

            {/*{router === 'home' && (*/}
            {/*    <HomeScreen handleExecCall={handleExecCall} />*/}
            {/*)}*/}

            {/*{router === 'schedule' && (*/}
            {/*    <ScheduleScreen />*/}
            {/*)}*/}

            {/*{router === 'details-contact' && (*/}
            {/*    <DetailsContactScreen handleExecCall={handleExecCall} />*/}
            {/*)}*/}

            {/*{router === 'detail-history' && (*/}
            {/*    <DetailHistoryScreen handleExecCall={handleExecCall} />*/}
            {/*)}*/}

            {/*{router === 'edit-contact' && (*/}
            {/*    <EditContactScreen />*/}
            {/*)}*/}

            {/*{router === 'create-contact' && (*/}
            {/*    <CreateContactScreen />*/}
            {/*)}*/}

            {/*{router === 'settings' && (*/}
            {/*    <SettingsScreen />*/}
            {/*)}*/}

            {/*{router === 'profile' && (*/}
            {/*    <ProfileScreen />*/}
            {/*)}*/}

            {/*{router === 'settings-themes' && (*/}
            {/*    <ThemesScreen />*/}
            {/*)}*/}

            {/*{router === 'settings-sound' && (*/}
            {/*    <SoundSettingsScreen />*/}
            {/*)}*/}


            {/*{router === 'send-messages' && (*/}
            {/*    <SendMessagesScreen />*/}
            {/*)}*/}

            {router === 'call-in-progress' && (
                <CallInProgress />
            )}
        </>

    );
}

export default Router;
